import axios from 'axios';

const updateFallback = params => axios.put('fallback', params);

export { updateFallback };
